<template>
  <Component :is="tag" class="flex aspect-[0.8] size-full lg:hidden lg:min-w-px">
    <div class="flex w-full flex-col items-center justify-center" @click.prevent="$emit('click')">
      <UiButton severity="quaternary" class="flex size-10 items-center justify-center rounded-full">
        <UiIcon name="chevron-down" class="size-4 -rotate-90" />
      </UiButton>
      <p class="mt-2 w-full text-center text-sm font-medium"><slot>Показать все</slot></p>
    </div>
  </Component>
</template>

<script lang="ts" setup>
import UiButton from './UiButton.vue'
import UiIcon from './UiIcon.vue'

type PropType = {
  tag?: string
}
type EmitType = {
  (e: 'click'): void
}

withDefaults(defineProps<PropType>(), {
  tag: 'div'
})
defineEmits<EmitType>()
</script>
